// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_root__22ca5","image":"Icon_image__17PVL","title":"Icon_title__oDVbU"};